import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";
import Topmenuright from "../Components/Topmenuright";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function NewsAdmin() {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [newsList, setNewsList] = useState([]);
  const [editId, setEditId] = useState(null); // ✅ Track edit mode

  const fetchNews = () => {
    fetch("https://sbsedelhi.com/backend/wp-json/custom/v1/news-updates")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setNewsList(data);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const rawContent = convertToRaw(editorState.getCurrentContent());
      const htmlContent = draftToHtml(rawContent);

      let url = "https://sbsedelhi.com/backend/wp-json/custom/v1/news-updates";
      let method = "POST";

      if (editId) {
        url = `https://sbsedelhi.com/backend/wp-json/custom/v1/news-updates/${editId}`;
        method = "PUT"; // ✅ Update existing
      }

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: htmlContent }),
      });

      if (!res.ok) throw new Error("Failed to save news");

      setMessage(editId ? "✏️ News updated successfully!" : "✅ News added successfully!");
      setEditorState(EditorState.createEmpty());
      setEditId(null);
      fetchNews();
    } catch (err) {
      setMessage("❌ Failed to save news");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this news?")) return;

    try {
      const res = await fetch(
        `https://sbsedelhi.com/backend/wp-json/custom/v1/news-updates/${id}`,
        { method: "DELETE" }
      );

      if (!res.ok) throw new Error("Failed to delete");

      setMessage("🗑️ News deleted successfully!");
      fetchNews();
    } catch (err) {
      setMessage("❌ Failed to delete news");
    }
  };

  const handleEdit = (item) => {
    const blocksFromHtml = htmlToDraft(item.content || "");
    if (blocksFromHtml) {
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(EditorState.createWithContent(contentState));
    }
    setEditId(item.id);
  };

  return (
    <div>
      <Helmet>
        <title>News Admin</title>
      </Helmet>
      <Header />
      <div className="inner-main-navigation container">
        <Topmenuright />
      </div>

      <div className="container main-contant">
        <div className="inner-page-container">
          <div
            style={{
              maxWidth: 700,
              margin: "40px auto",
              padding: 20,
              border: "1px solid #ddd",
              borderRadius: 8,
            }}
          >
            <h2 style={{ marginBottom: 20 }}>News Updates Admin</h2>

            <form onSubmit={handleSubmit}>
              <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={(state) => setEditorState(state)}
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "list",
                    "textAlign",
                    "link",
                    "history",
                  ],
                }}
              />

              <button
                type="submit"
                disabled={loading}
                style={{
                  marginTop: 20,
                  padding: "12px 20px",
                  background: editId ? "#28a745" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  cursor: "pointer",
                }}
              >
                {loading ? "Saving..." : editId ? "Update News" : "Add News"}
              </button>

              {editId && (
                <button
                  type="button"
                  onClick={() => {
                    setEditorState(EditorState.createEmpty());
                    setEditId(null);
                  }}
                  style={{
                    marginLeft: 10,
                    padding: "12px 20px",
                    background: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              )}
            </form>

            {message && <p style={{ marginTop: 16, fontWeight: 600 }}>{message}</p>}

            <h3 style={{ marginTop: 30 }}>All News Updates</h3>
            <ul style={{ marginTop: 10, paddingLeft: 0, listStyle: "none" }}>
              {newsList.length > 0 ? (
                newsList.map((item) => (
                  <li
                    key={item.id}
                    style={{
                      marginBottom: 10,
                      padding: 10,
                      borderBottom: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: item.content }} />
                    <div>
                      <button
                        onClick={() => handleEdit(item)}
                        style={{
                          marginRight: 8,
                          padding: "6px 12px",
                          background: "orange",
                          color: "#fff",
                          border: "none",
                          borderRadius: 4,
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(item.id)}
                        style={{
                          padding: "6px 12px",
                          background: "red",
                          color: "#fff",
                          border: "none",
                          borderRadius: 4,
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </li>
                ))
              ) : (
                <p>No news added yet.</p>
              )}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewsAdmin;
